import { useParams, useNavigate } from "react-router-dom";
import Stepper from "../../components/Stepper";

export default function TermoExpositor() {
  const { id } = useParams();
  const navigate = useNavigate();

  // 🔥 termos por evento (EXPOSITOR)
  const termos = {
    "feinsul-2026": "/imagens/termos/TermoExpositorFeinsul.png",
    "expo-agro-2026": "/imagens/termos/TermoExpositorFeinsul.png",
  };

  const handleContinuar = () => {
    navigate(`/evento/${id}/expositor`);
  };

  const termoAtual = termos[id];

  return (
    <div
      className="page-bg"
      style={{ backgroundImage: 'url("/imagens/FundoGeral.png")' }}
    >
      <div className="termo-wrapper">
        <div className="page">

          <div className="termo-container">
            <h1>Termo de Expositor</h1>
            <p>
              Leia atentamente os termos específicos para expositores e clique em continuar.
            </p>
          </div>

          {termoAtual ? (
            <img
              src={termoAtual}
              alt="Termo expositor"
              className="termo-img"
            />
          ) : (
            <p style={{ color: "red" }}>
              Termo não configurado para este evento.
            </p>
          )}

          <button onClick={handleContinuar} className="link-button">
            Concordar e continuar
          </button>

        </div>

        <Stepper etapaAtual={2} />
      </div>
    </div>
  );
}